export { ReactComponent as CaseScheduleIcon } from './icons/case-schedule.svg';
export { ReactComponent as AssembleTrayIcon } from './icons/assemble-tray.svg';
export { ReactComponent as AssignToCaseIcon } from './icons/assign-to-case.svg';
export { ReactComponent as ReleaseToDeconIcon } from './icons/release-to-decon.svg';
export { ReactComponent as TrackAssetIcon } from './icons/track-asset.svg';
export { ReactComponent as EntityManagementIcon } from './icons/entity-management.svg';
export { ReactComponent as LiveOrIcon } from './icons/live-or.svg';
export { ReactComponent as InsightsIcon } from './icons/insights.svg';
export { ReactComponent as UserRolesIcon } from './icons/user-roles.svg';
export { ReactComponent as CobotSetupIcon } from './icons/cobot-setup.svg';
export { ReactComponent as TrackerSetupIcon } from './icons/tracker-setup.svg';
export { ReactComponent as OemTrayIcon } from './icons/oem-tray.svg';
export { ReactComponent as HelpSupportIcon } from './icons/help-support.svg';
export { ReactComponent as BuildCartNavIcon } from './icons/build-cart-nav.svg';
